const templateUrl = require('./description.html');

const app = angular.module('msi.products.product.description', []);

app.component('ogProductDescription', {
  bindings: {
    item: '<ogFor'
  },
  templateUrl: templateUrl
});

module.exports = app.name;
